module.exports = __webpack_public_path__ + "static/media/step2_j.3856a782.png";